import { add } from 'date-fns';
import { cookiesHelper } from '@saucelabs/sl-util-helpers';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import * as actions from './actions';
import { getTopLevelDomain, parseJSON } from './utils';
import { DEVICES_ASSIGNED_COOKIE } from './constants';

export const prepareDevicesCookies = () => ({
  domain: getTopLevelDomain(),
  expireDate: add(new Date(), { minutes: 1 }),
  devices: parseJSON(cookiesHelper.getItem(DEVICES_ASSIGNED_COOKIE)) ?? {},
});

export const storeDevicesInCookies = (payload) => {
  const { domain, expireDate, devices } = prepareDevicesCookies();

  devices[payload.deviceDescriptorId] = payload.teamId ?? null;
  cookiesHelper.setItem(DEVICES_ASSIGNED_COOKIE, JSON.stringify(devices), expireDate, '/', domain, false);
};

export const removeDevicesInCookies = (payload) => {
  const { domain, expireDate, devices } = prepareDevicesCookies();

  Object.keys(devices).forEach((key) => {
    if (devices[key] === payload.id) {
      devices[key] = null;
    }
  });

  cookiesHelper.setItem(DEVICES_ASSIGNED_COOKIE, JSON.stringify(devices), expireDate, '/', domain, false);
};

export const assignDeviceToTeam = (payload) => (dispatch) => (
  dispatch(actions.assignDeviceToTeam(payload))
    .then(() => {
      const { deviceName, teamName } = payload;
      storeDevicesInCookies(payload);
      return dispatch(
        notificationActions.notifySuccess(`${deviceName} was successfully assigned to ${teamName}`));
    })
    .catch(() => dispatch(notificationActions.notifyDanger('Assigning a device failed. Please try again.')))
);

export const unAssignDeviceFromTeam = (payload) => (dispatch) => (
  dispatch(actions.unAssignDeviceFromTeam(payload))
    .then(() => {
      storeDevicesInCookies(payload);
      return dispatch(
        notificationActions.notifySuccess(`${payload.deviceName} was successfully unassigned`));
    })
    .catch(() => dispatch(notificationActions.notifyDanger('Unassigning a device failed. Please try again.'))));

export const updateDeviceSettings = (payload) => (dispatch) => (
  dispatch(actions.updateDeviceSettings(payload))
);
